/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatedGroup
 */
export interface CreatedGroup {
    /**
     * 
     */
    id: string;
}

/**
 * Check if a given object implements the CreatedGroup interface.
 */
export function instanceOfCreatedGroup(value: object): value is CreatedGroup {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreatedGroupFromJSON(json: any): CreatedGroup {
    return CreatedGroupFromJSONTyped(json, false);
}

export function CreatedGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatedGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function CreatedGroupToJSON(json: any): CreatedGroup {
    return CreatedGroupToJSONTyped(json, false);
}

export function CreatedGroupToJSONTyped(value?: CreatedGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

